import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiFileText, FiUsers, FiHome, FiBarChart2, FiClock, FiUser, FiRefreshCw, FiExternalLink, FiCode } from 'react-icons/fi';
import ShieldCheckIcon from '../ShieldCheckIcon';
import { CONTENT_SECTIONS } from './hubData';
import { HubHeader, hubPath, useHubSite } from './shared';

const ICONS: Record<string, React.ReactNode> = {
    'news-media': <FiFileText />,
    'board-management': <FiUsers />,
    'corporate-governance': <ShieldCheckIcon />,
    'other-documents': <FiFileText />,
    'company-details': <FiHome />,
    'capital-structure': <FiBarChart2 />,
};

const STEPS = [
    ['Add or edit here', 'Type the details, upload a PDF or a photo.'],
    ['Investi updates the widget', 'No code, no developer, no waiting.'],
    ['Investors see it on the website', 'Check it any time with “View website”.'],
];

// Website Hub › Website content (spec 404:9645)
const WebsiteContent: React.FC = () => {
    const history = useHistory();
    const { host, url } = useHubSite();

    return <>
        <HubHeader title="Website Content" sub={`Add, edit or remove what investors see on ${host} — changes appear on the website straight away`}>
            <button type="button" className="btn-outline with-icon" onClick={() => history.push('/client-settings/widgets/list')}><FiCode /> Widget Settings</button>
        </HubHeader>

        <div className="hub-sections" data-tour="hub-content-sections">
            {CONTENT_SECTIONS.map(s => <section key={s.slug} className="card hub-section-card" data-tour={`hub-content-${s.slug}`}>
                <div className="section-title">
                    <span className="icon-tile">{ICONS[s.slug]}</span>
                    <div className="text"><h2>{s.title}</h2><div className="hint">{s.summary}</div></div>
                </div>
                <div className="meta">
                    <span><FiClock /> Last updated {s.updated}</span>
                    <span>{s.automatic ? <FiRefreshCw /> : <FiUser />} Updated by {s.updatedBy}</span>
                </div>
                <div className="buttons">
                    <button type="button" className="btn-primary" onClick={() => history.push(hubPath('content', s.slug))}>Manage</button>
                    <a className="btn-outline with-icon" href={url(s.path)} target="_blank" rel="noopener noreferrer"><FiExternalLink /> View on Website</a>
                </div>
            </section>)}
        </div>

        <section className="hub-how">
            <h2>You never need to log in to WordPress</h2>
            <p>Your website stays on WordPress. What you change here appears through the Investi widgets, which are set up under Client settings › Widgets.</p>
            <div className="steps">
                {STEPS.map(([t, s], i) => <div key={t}><span className="n">{i + 1}</span><div className="t"><strong>{t}</strong><span>{s}</span></div></div>)}
            </div>
        </section>
    </>;
};

export default WebsiteContent;
